import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c938109"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "core",
  name: "core"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "image"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_typography = _resolveComponent("a-typography")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode("<a-typography-title :level=\"1\">"),
      _createCommentVNode("  <span>三大核心产品</span>"),
      _createCommentVNode("  <template v-if=\"$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)\">，</template>"),
      _createCommentVNode("  <br v-else />"),
      _createCommentVNode("  <span>高效构建Serverless基础架构</span>"),
      _createCommentVNode("</a-typography-title>"),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.core, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", `i_${index+1}`])
        }, [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                class: "box_content",
                xs: 24,
                md: 12,
                order: index%2===0&&_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD)?1:2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_typography, null, {
                    default: _withCtx(() => [
                      (_ctx.$Store.Public().isGridMatch('<',_ctx.$Enum.GridEnum.MD))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                        : _createCommentVNode("v-if", true),
                      _createVNode(_component_a_typography_title, { level: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title_en), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */),
                      _createVNode(_component_a_typography_title, { level: 3 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */),
                      _createVNode(_component_a_typography_paragraph, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */),
                      _createVNode(_component_a_space, {
                        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
                      }, {
                        default: _withCtx(() => [
                          (item.clickMore)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "link",
                                class: "button_n_2",
                                target: "_blank",
                                onClick: item.clickMore
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 了解更多 ")
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode("<a-button v-if=\"item.clickFree\""),
                          _createCommentVNode("          type=\"link\" class=\"button_n_3\" target=\"_blank\""),
                          _createCommentVNode("          @click=\"item.clickFree\">"),
                          _createCommentVNode("  免费体验"),
                          _createCommentVNode("</a-button>")
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["size"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["order"]),
              _createVNode(_component_a_col, {
                class: "box_image",
                xs: 0,
                md: 12,
                order: index%2!==0&&_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD)?1:2
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["order"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */),
          _createCommentVNode("<HomeVideo v-if=\"index===expand.core.length-1\" />")
        ], 2 /* CLASS */))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}